import type { BrandManager } from '@@partner:types:app'
import type { CRUD_Variables, GQL_Edge } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_EMPLOYEE_FIELDS,
  SHORTCUT_PAGE_INFO_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllBrandManagersQueryResult {
  brandManagers: GQL_Edge<BrandManager[]>
}

export interface AllBrandManagersQueryVariables extends CRUD_Variables {}

const GQL_QUERY_ALL_BRAND_MANAGERS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    brandManagers: allBrandManagers(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_EMPLOYEE_FIELDS}
        email
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllBrandManagers = (
  variables: AllBrandManagersQueryVariables
) =>
  useQuery<AllBrandManagersQueryResult, AllBrandManagersQueryVariables>(
    GQL_QUERY_ALL_BRAND_MANAGERS,
    { variables, fetchPolicy: 'cache-and-network' }
  )
